import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../../integration-store';
import { ISalasaCredentialsModel } from '../../../../../../models/IntegrationsTypes'

class SalasaCredentialsStore implements ICredentialsStore {
    private _changes: ISalasaCredentialsModel = {} as ISalasaCredentialsModel;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public get apiKey() { return this._changes.api_key; };
    public get apiToken() { return this._changes.api_token; };
    public get warehouse() { return this._changes.warehouse; };
    public get accountId() { return this._changes.account_id; };

    setApiKey(value: string) {
        this._changes.api_key = value;
    };

    setApiToken(value: string) {
        this._changes.api_token = value;
    };

    setWarehouse(value: string) {
        this._changes.warehouse = value;
    };

    setAccountId(value: string) {
        this._changes.account_id = value;
    };

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default SalasaCredentialsStore;
